/* Publish by EComposer at 2025-08-11 01:58:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f3g5n1tc1sg"]=  window.__ectimmers["ecom-f3g5n1tc1sg"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-f3g5n1tc1sg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3g5n1tc1sg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9iwivq3ksy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9iwivq3ksy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6e1mc0kjtqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6e1mc0kjtqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6tw97yf3nm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6tw97yf3nm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24r7dafu23a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24r7dafu23a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyxqfyg709').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyxqfyg709', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2g397ier5wq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2g397ier5wq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yiyc3t6lj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yiyc3t6lj4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3v6f33mwk3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3v6f33mwk3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hujvst45pk6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hujvst45pk6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p26rrm3kov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p26rrm3kov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rli83sq8ulm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rli83sq8ulm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mx3ksa3ehv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mx3ksa3ehv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9rs4hq5iket').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9rs4hq5iket', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lubm791vm6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lubm791vm6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvsq7tim43b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvsq7tim43b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6yczod9vh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6yczod9vh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uv287bhdu8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uv287bhdu8b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cp0eh2bl22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cp0eh2bl22', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xj9trgxsluk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xj9trgxsluk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nl0qe4v0fua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nl0qe4v0fua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-km96br3b03').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-km96br3b03', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-05cipea3evf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-05cipea3evf8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ltu86qi9g3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ltu86qi9g3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3notg9z0xff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3notg9z0xff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozbw9df0vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozbw9df0vt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfqhqpvxbue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfqhqpvxbue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gq2waybjoa8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gq2waybjoa8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fq1shkfaf2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fq1shkfaf2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s91mad265se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s91mad265se', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zlmxj1y93sl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zlmxj1y93sl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qzhmv6b726r"]=  window.__ectimmers["ecom-qzhmv6b726r"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-qzhmv6b726r"]["k2cc23a9a"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qzhmv6b726r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzhmv6b726r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ggn9xcfih8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ggn9xcfih8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8ak21zlnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8ak21zlnm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7rkwj3wkxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7rkwj3wkxf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbcvlecjhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbcvlecjhk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o33e8cahtlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o33e8cahtlc', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bqgmuphk1r6"]=  window.__ectimmers["ecom-bqgmuphk1r6"] || {};
var g,b,u,v,$,x;let e=this.$el;if(!e)return;let i=this.isLive;const t=(g=this.settings.disable_auto_close)!=null?g:!1,n=(b=this.settings.disable_auto_close__tablet)!=null?b:!1,s=(u=this.settings.disable_auto_close__mobile)!=null?u:!1,o=(v=this.settings.scroll_on_mobile)!=null?v:!1,a=($=this.settings.disable_effect)!=null?$:!1,r=(x=this.settings.close_all)!=null?x:!1,c=e.querySelectorAll(".ecom-accordion__item > .ecom-accordion__title");function m(w){const f=w.getBoundingClientRect();return f.top>=0&&f.left>=0&&f.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&f.right<=(window.innerWidth||document.documentElement.clientWidth)}function l(w){let f=window.screen.width;window.EComposer.TEMPLATE_ID||(f=window.innerWidth),w.forEach((k,L)=>{let z=k.parentNode.querySelector(".ecom-accordion__body");!a&&z&&z.classList.add("ecom-effect-accodion"),L==0&&(z.style.height=z.clientHeight+"px"),k.onclick=function(M){M.preventDefault();let T=this.parentNode,S=T.parentNode;const q=S.querySelectorAll(".ecom-accordion__item"),P=S.querySelectorAll(".ecom-accordion__title");if(T.classList&&T.classList.remove("ecom-item-group-init"),this.classList&&this.classList.contains("ecom-item-active"))s&&f<768||n&&f>767&&f<1025||t&&f>1024?(this.classList.remove("ecom-item-active"),T.querySelector(".ecom-accordion__body").style.height="0px",T.querySelector(".ecom-accordion__title").classList.remove("ecom-item-active"),T.classList.remove("ecom-item-active")):(q.forEach(D=>h(D)),P.forEach(D=>D.classList.remove("ecom-item-active")));else{s&&f<768||n&&f>767&&f<1025||t&&f>1024||(q.forEach(N=>h(N)),P.forEach(N=>N.classList.remove("ecom-item-active"))),k.classList.add("ecom-item-active"),T.classList.add("ecom-item-active");let D=k.parentNode.querySelector(".ecom-accordion__body");k.parentNode.closest(".ecom-accordion__body")&&(k.parentNode.closest(".ecom-accordion__body").style.height="auto"),D.style.height="auto";let W="auto";a||(W=i?D.clientHeight+"px":"auto",D.classList.add("ecom-effect-accodion")),D.style.height="0px",setTimeout(()=>{D.style.height=W},10)}window.dispatchEvent(new window.Event("renderScroll")),setTimeout(()=>{window.dispatchEvent(new window.Event("renderScroll")),o?m(this)||R():!m(this)&&f>1024&&R()},50);function A(D){let W=0;if(D.offsetParent){do W+=D.offsetTop;while(D=D.offsetParent);return[W]}}function R(D){window.scrollTo(0,A(e)-100)}}})}function h(w){w.classList.remove("ecom-item-active"),w.querySelector(".ecom-accordion__body").style.height="0"}l(c),r||setTimeout(()=>{e.querySelector(".ecom-item-group-init")&&e.querySelector(".ecom-item-group-init").classList.remove("ecom-item-group-init")},500);function y(){let w=window.location.hash;if(w){let f=e.querySelector(`[data-target="${w}"]`);if(f){f.click();let k=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});f.dispatchEvent(k);let M=f.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,M)}}}setTimeout(function(){y()},300),window.addEventListener("resize",function(){l(c)}),window.addEventListener("hashchange",y,!1)

                    });
                    
                        document.querySelectorAll('.ecom-bqgmuphk1r6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqgmuphk1r6', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sdhahvkipjl"]=  window.__ectimmers["ecom-sdhahvkipjl"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-sdhahvkipjl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdhahvkipjl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubve9e6ovu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubve9e6ovu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wqkfhp2h69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wqkfhp2h69', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j3hl946ybzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j3hl946ybzj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn91im6h42v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn91im6h42v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylt5pz25omk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylt5pz25omk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hs0ii1wvkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hs0ii1wvkk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c32l8nxubwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c32l8nxubwc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66j6a3b6axh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66j6a3b6axh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvs4khg91gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvs4khg91gs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cea8vdg4w8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cea8vdg4w8t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbhuas3yhco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbhuas3yhco', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0bahxnzykj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0bahxnzykj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}